(function () {
    'use strict';

    angular
        .module('rms.common')
        .controller('rmsRequisitionMassApprovalCtrl', rmsRequisitionMassApprovalCtrl);


    function rmsRequisitionMassApprovalCtrl(GenericModel, lodash, $scope) {
        var apr_ctrl = this;
        apr_ctrl.options = lodash.get($scope, '$parent.vm.options.structure.options', {});
        apr_ctrl.model = lodash.get($scope, '$parent.vm.options.model', {});
        apr_ctrl.loading = true;
        apr_ctrl.is_empty = false;
        apr_ctrl.allowed_list = [];
        apr_ctrl.disallowed_list = [];
        apr_ctrl.tab_const = {
            SELECTED: 'selected',
            UNAFFECTED: 'unaffected',
        };
        apr_ctrl.active_tab = apr_ctrl.tab_const.SELECTED;

        apr_ctrl.remove_from_list = remove_from_list;

        var url = lodash.get(apr_ctrl.options, 'datasource.url', null);
        var method = lodash.get(apr_ctrl.options, 'datasource.method', 'get');
        var type = lodash.get(apr_ctrl.options, 'type', null);
        if (!!url) {
            var resource = GenericModel(url);
            resource[method]({
                selected: lodash.get(apr_ctrl.model, 'selected', []),
                type: lodash.get(apr_ctrl.options, 'type', null),
            }).$promise.then(function(res) {
                apr_ctrl.loading = false;
                apr_ctrl.allowed_list = lodash.get(res, 'allowed_formatted', []);
                apr_ctrl.disallowed_list = lodash.get(res, 'disallowed_formatted', []);
                lodash.set($scope, '$parent.vm.options.model.allowed_ids',  lodash.get(res, 'allowed_ids', []));
                apr_ctrl.is_empty = !(apr_ctrl.allowed_list.length > 0);
                apr_ctrl.type = type;
                // apr.
            });
        }

        function remove_from_list(row) {
            lodash.remove(apr_ctrl.allowed_list, {id: row.id});

            lodash.set($scope, '$parent.vm.options.model.allowed_ids', apr_ctrl.allowed_list.map(function(_row) {
                return {id: _row.id};
            }));
        }
    }
})();